export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-4xl mx-auto">
          <div className="flex-1 w-full max-w-[360px] lg:max-w-none">
            <div className="relative">
              <div className="aspect-[3/4] max-w-[260px] mx-auto rounded-2xl overflow-hidden border-4 border-background-50 shadow-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20content%20discovery%20app%20interface%20with%20warm%20golden%20accents%2C%20sophisticated%20minimalist%20design%2C%20clean%20card%20layout%2C%20soft%20natural%20lighting%2C%20premium%20UI%20aesthetic%2C%20editorial%20style&width=600&height=800&seq=app-mockup&orientation=portrait"
                  alt="探花系列移动端体验"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 left-1/2 -translate-x-1/2 bg-background-50 rounded-full px-4 py-1.5 border border-background-200/70 shadow-sm">
                <span className="text-xs text-foreground-600 font-medium whitespace-nowrap">移动端同步浏览</span>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-smartphone-line"></i>
              移动体验
            </div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              随时随地 · 畅享探花
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              探花系列移动端适配完美，无论你使用手机还是平板，都能流畅浏览探花大神合集、探花一区精选与探花91社区内容。
              探花探花移动版保留全部核心功能，让你随时随地发现探花精选资源。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-apple-fill"></i>
                iOS 版入口
              </a>
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-foreground-500 text-foreground-700 hover:text-foreground-900 font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-android-fill"></i>
                Android 版入口
              </a>
            </div>

            <div className="mt-5 flex items-center justify-center lg:justify-start gap-4 text-[11px] text-foreground-400">
              <div className="flex items-center gap-1">
                <i className="ri-shield-check-line text-green-500"></i>
                <span>安全浏览</span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-flashlight-line text-primary-500"></i>
                <span>极速加载</span>
              </div>
              <div className="flex items-center gap-1">
                <i className="ri-moon-line text-secondary-500"></i>
                <span>夜间模式</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}